<template>
    <v-dialog
        v-model="showDialog"
        width="800"
        persistent
    >
        <v-card>
            <v-form
                ref="form"
                @submit.prevent="submitForm"
            >
                <v-card-title style="background-color: #009688; color: white;">
                    New Clinic
                </v-card-title>
                <v-card-text style="padding: 20px;">
                    <v-autocomplete
                        v-model="selectedHosp"
                        hide-details
                        dense
                        :items="ClinicItems"
                        label="Clinic Name"
                        item-text="nameAndCode"
                        return-object
                        clearable
                        color="teal"
                        :loading="loading"
                        multiple
                        chips
                    >
                        <!-- Custom template for selected clinic -->
                        <template #selection="item">
                            <v-chip
                                style="display: inline-block; margin: 3px;"
                                v-bind="item.attrs"
                                :input-value="item.selected"
                                close
                                @click="item.select"
                                @click:close="remove(item.item.hosp_msu_code)"
                            >
                                <v-chip
                                    v-if="item.item.hosp_msu_code || item.item.group_id"
                                    small
                                    :color="item.item.type === 'SINGLE' ? 'teal' : 'blue'"
                                    class="white--text"
                                    style="font-weight: 700;"
                                >
                                    {{ item.item.type === 'SINGLE' ? item.item.hosp_msu_code : item.item.group_id }}
                                </v-chip> {{ item.item.hosp_name }}
                            </v-chip>
                        </template>
                        <!-- Custom template for clinic selection options -->
                        <template #item="item">
                            <template v-if="typeOfItem">
                                <v-chip
                                    v-if="item.item.hosp_msu_code || item.item.group_id"
                                    small
                                    :color="item.item.type === 'SINGLE' ? 'teal' : 'blue'"
                                    class="white--text"
                                    style="font-weight: 700;"
                                >
                                    {{ item.item.type === 'SINGLE' ? item.item.hosp_msu_code : item.item.group_id }}
                                </v-chip>&nbsp;{{ item.item.hosp_name }}
                            </template>
                        </template>
                    </v-autocomplete>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn
                        color="teal darken-1"
                        outlined
                        @click="showDialog = false"
                    >
                        close
                    </v-btn>
                    <v-btn
                        type="submit"
                        color="teal darken-1 white--text"
                    >
                        add
                    </v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
    props: ['show', 'data', 'notif'],
    data:()=>({
        items: [],
        loading: false,
        selectedHosp: null
    }),
    computed: {
        ...mapGetters(['fetchAcuProvidersData', 'insertAccountClinicData', 'viewAccountClinicsData']),
        typeOfItem() {
            return typeof this.data.item !== 'object'
        },
        showDialog: {
            get() {
                return this.show
            },
            set() {
                this.handleCloseDialog()
            }
        },
        ClinicItems() {
            if (
                this.fetchAcuProvidersData &&
                this.fetchAcuProvidersData.status === 200 &&
                this.viewAccountClinicsData &&
                this.viewAccountClinicsData.status === 200
            ) {
                const acuData = this.fetchAcuProvidersData.data
                const alreadyAddedClinic = this.viewAccountClinicsData.data

                const filteredArr = acuData
                    .filter(item => {
                        // Exclude item if its hosp_msu_code matches any alreadyAddedClinic.MSU_C
                        return !alreadyAddedClinic.some(clinic => (item.type === 'SINGLE' && clinic.MSU_C === item.hosp_msu_code || item.type === 'GROUP' && clinic.MSU_C === item.group_id))
                    })
                    .map(item => ({
                        ...item,
                        nameAndCode: `${item.type === 'SINGLE' ? item.hosp_msu_code : item.group_id} ${item.hosp_name}`
                    }))

                return filteredArr
            }
            return []
        }
    },
    watch: {
        async insertAccountClinicData(newVal) {
            if (newVal) {
                if (newVal.status === 201) {
                    this.notif.type = 'success'
                    this.notif.color = 'success'
                    this.notif.timeout = 5000
                    this.notif.msg = 'New Clinic has been added.'
                    this.notif.show = true
                    this.showDialog = false
                    this.selectedHosp = null
                    await this.viewAccountClinics({ ACCT_N: this.data.ACCT_N })
                    // this.$emit('refreshAcuList', this.data.ACCT_N)
                } else {
                    this.notif.type = 'error'
                    this.notif.color = 'error'
                    this.notif.timeout = 5000
                    this.notif.msg = newVal.state
                    this.notif.show = true
                }
            }
        },
        fetchAcuProvidersData() {
            this.loading = false
        }
    },
    mounted() {
        this.fetchAcuProviders()
    },
    methods: {
        ...mapActions(['fetchAcuProviders', 'insertAccountClinic', 'viewAccountClinics', 'acuActiveList']),
        handleCloseDialog() {
            this.selectedHosp = null
            this.$emit('closeDialog')
        },
        remove(msuCode) {
            const indexOfSelected = this.selectedHosp.findIndex( hosp => hosp.hosp_msu_code === msuCode )
            if (indexOfSelected >= 0) {
                this.selectedHosp.splice(indexOfSelected, 1)
            }
        },
        submitForm() {
            this.selectedHosp.map(item => {
                this.insertAccountClinic({
                    'ACCT_N': this.data.ACCT_N,
                    'MSU_C': item.type === 'SINGLE' ? item.hosp_msu_code : item.group_id,
                    'TYPE': item.type
                })
            })
        }
    }
}
</script>
